import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import type { DrawerNode } from './drawer.types';
type UseDrawerProps = {
  onCloseAll: () => void;
  onOpenChange: (isOpen: boolean) => void;
  onOpenChangeComplete: (isOpen: boolean) => void;
};
export function useDrawer(t0) {
  const $ = _c(13);
  const {
    onCloseAll,
    onOpenChange,
    onOpenChangeComplete
  } = t0;
  const [activeNode, setActiveNode] = useState(null);
  const activeTriggerRef = useRef(null);
  const closeButtonRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (node, trigger) => {
      activeTriggerRef.current = trigger;
      setActiveNode(node);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openNode = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setActiveNode(null);
      requestAnimationFrame(() => activeTriggerRef.current?.focus());
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeChild = t2;
  let t3;
  if ($[2] !== onOpenChange) {
    t3 = nextIsOpen => onOpenChange(nextIsOpen);
    $[2] = onOpenChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOpenChange = t3;
  let t4;
  if ($[4] !== onOpenChangeComplete) {
    t4 = isNowOpen => {
      if (!isNowOpen) {
        setActiveNode(null);
      }
      onOpenChangeComplete(isNowOpen);
    };
    $[4] = onOpenChangeComplete;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleOpenChangeComplete = t4;
  let t5;
  if ($[6] !== onCloseAll) {
    t5 = () => onCloseAll();
    $[6] = onCloseAll;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const closeAll = t5;
  let t6;
  if ($[8] !== activeNode || $[9] !== closeAll || $[10] !== handleOpenChange || $[11] !== handleOpenChangeComplete) {
    t6 = {
      activeNode,
      closeAll,
      closeButtonRef,
      closeChild,
      handleOpenChange,
      handleOpenChangeComplete,
      openNode
    };
    $[8] = activeNode;
    $[9] = closeAll;
    $[10] = handleOpenChange;
    $[11] = handleOpenChangeComplete;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}